
import React, { useEffect, useRef, useState, useCallback } from 'react';
import styles from '../../assets/scss/Invoice/AddItemPopup.module.scss';
import { useGetItemBagsQuery, useGetItemcatQuery } from '../../slices/admin/admin';
import { BaseURL } from '../../lib/api';

const AddItemPopup = ({ onClose, onSave, itemToEdit, storeId }) => {
  const [formData, setFormData] = useState({
    category: '',
    description: '',
    bag: '',
    quality: '',
    quantity: '',
    count: '',
  });

  // console.log(storeId,"storeId22");

  const [imagePreview, setImagePreview] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const fileInputRef = useRef(null);
  const [errors, setErrors] = useState({});



  const { data: bagData } = useGetItemBagsQuery();
  // const { data: catData } = useGetItemcatQuery();
  const { data: catData } = useGetItemcatQuery(storeId, {
    skip: !storeId,
  });


  // Cleanup blob URLs
  // useEffect(() => {
  //   return () => {
  //     if (imagePreview && imagePreview.startsWith('blob:')) {
  //       URL.revokeObjectURL(imagePreview);
  //     }
  //   };
  // }, [imagePreview]);

  useEffect(() => {
    if (itemToEdit) {
      setFormData({
        category: itemToEdit.name || '',
        description: itemToEdit.description || '',
        bag: itemToEdit.bag || '',
        quality: itemToEdit.quality || '',
        quantity: itemToEdit.quantity || '',
        count: itemToEdit.productCount || '',
      });

      let previewUrl = null;
      if (itemToEdit.imagePreview) {
        previewUrl = itemToEdit.imagePreview;
      } else if (itemToEdit.image && typeof itemToEdit.image === 'string') {
        previewUrl = itemToEdit.image.startsWith('http')
          ? itemToEdit.image
          : `${BaseURL}/${itemToEdit.image}`;
      }
      setImagePreview(previewUrl);
      setImageFile(itemToEdit.image || null);
    }
  }, [itemToEdit]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.category) newErrors.category = 'Item Category is required';
    if (!formData.bag) newErrors.bag = 'Item Scales is required';
    if (!formData.quality) newErrors.quality = 'Item Quality is required';
    if (formData.bag === 'kilogram' && !formData.quantity) newErrors.quantity = 'Item Quantity is required';
    if (formData.bag && formData.bag !== 'kilogram' && !formData.count) newErrors.count = 'Item Count is required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleImageClick = () => fileInputRef.current?.click();

  const handleImageChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (imagePreview && imagePreview.startsWith('blob:')) {
      URL.revokeObjectURL(imagePreview);
    }
    const url = URL.createObjectURL(file);
    setImagePreview(url);
    setImageFile(file);
  };

  // Fixed: Delay + Safe Remove (Google Translate + No Empty Screen)
  const handleRemoveImage = useCallback((e) => {
    e.stopPropagation(); // MOST IMPORTANT LINE DA!
    setTimeout(() => {
      if (imagePreview && imagePreview.startsWith('blob:')) {
        URL.revokeObjectURL(imagePreview);
      }
      setImagePreview(null);
      setImageFile(null);
      if (fileInputRef.current) fileInputRef.current.value = '';
    }, 0);
  }, [imagePreview]);

  const handleSubmit = () => {
    if (validate()) {
      onSave({
        name: formData.category,
        description: formData.description,
        bag: formData.bag,
        quality: formData.quality,
        quantity: formData.bag === 'kilogram' ? Number(formData.quantity) || 0 : 0,
        productCount: formData.bag !== 'kilogram' ? Number(formData.count) || 0 : 0,
        image: imageFile,
        imagePreview: imagePreview || null,
      });
      onClose();
    }
  };

  return (
    <div className={styles.popupForm}>
      <div className={styles.header}>
        <h2 className={styles.tittle}>Add Item</h2>
        <span className={styles.closeIcons} onClick={onClose}>X</span>
      </div>

      <div className={styles.closeIcon}>
        <div className={styles.grid}>

          {/* IMAGE UPLOAD - NOW 100% FIXED */}
          <div className={styles.uploadBox}>
            <label className={styles.inputLabel}>Item Image</label>
            <div className={styles.imageBox}>

              {imagePreview ? (
                <div className={styles.previewWrapper} key={imagePreview}>
                  {/* Only image is shown, not clickable */}
                  <img
                    src={imagePreview}
                    alt="Item preview"
                    className={styles.previewImage}
                  />

                  {/* Only X button triggers remove */}
                  <button
                    type="button"
                    className={styles.removeBtn}
                    onClick={handleRemoveImage}
                    aria-label="Remove image"
                  >
                    X
                  </button>
                </div>
              ) : (
                /* Drop area is clickable only when no image */
                <div
                  className={styles.dropArea}
                  onClick={handleImageClick}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => e.key === 'Enter' && handleImageClick()}
                >
                  Drag image here<br />or<br />
                  <span>Browse image</span>
                </div>
              )}

              <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                style={{ display: 'none' }}
                onChange={handleImageChange}
              />
            </div>
          </div>

          {/* Rest of form - unchanged */}
          {/* <div className={styles.inputGroup}>
            <label className={styles.inputLabel}>Item Category</label>
            <select name="category" className={styles.inputs} value={formData.category} onChange={handleChange}>
              <option value="">Select Item</option>
              {catData?.getAllItems?.map(item => (
                <option key={item._id} value={item.itemCategory}>{item.itemCategory}</option>
              ))}
            </select>
            {errors.category && <span className={styles.error}>{errors.category}</span>}
          </div> */}
          <div className={styles.inputGroup}>
            <label className={styles.inputLabel}>Item Category</label>

            <select
              name="category"
              className={styles.inputs}
              value={formData.category}
              onChange={handleChange}
            >
              <option value="">Select Item</option>

              {catData?.items?.map((item) => (
                <option key={item._id} value={item.itemCategory}>
                  {item.itemCategory}
                </option>
              ))}
            </select>

            {errors.category && (
              <span className={styles.error}>{errors.category}</span>
            )}
          </div>


          <div className={styles.inputGroup}>
            <label className={styles.inputLabel}>Item Descriptions</label>
            <input
              name="description"
              className={styles.input}
              type="text"
              placeholder="Item Descriptions"
              value={formData.description}
              onChange={handleChange}
            />
          </div>

          <div className={styles.inputGroup}>
            <label className={styles.inputLabel}>Item Scales</label>
            <select name="bag" className={styles.inputs} value={formData.bag} onChange={handleChange}>
              <option value="">Select Item</option>
              {bagData?.itemBags?.map(bag => (
                <option key={bag._id} value={bag.itemBag}>{bag.itemBag}</option>
              ))}
            </select>
            {errors.bag && <span className={styles.error}>{errors.bag}</span>}
          </div>

          <div className={styles.inputGroup}>
            <label className={styles.inputLabel}>Item Quality</label>
            <select name="quality" className={styles.inputs} value={formData.quality} onChange={handleChange}>
              <option value="">Select Item</option>
              <option value="High">High</option>
              <option value="Medium">Medium</option>
              <option value="Low">Low</option>
            </select>
            {errors.quality && <span className={styles.error}>{errors.quality}</span>}
          </div>

          {formData.bag === 'kilogram' ? (
            <div className={styles.inputGroupFull}>
              <label className={styles.inputLabel}>Item Quantity (kg)</label>
              <input name="quantity" className={styles.input} type="number" placeholder="Enter Quantity" value={formData.quantity} onChange={handleChange} />
              {errors.quantity && <span className={styles.error}>{errors.quantity}</span>}
            </div>
          ) : formData.bag && formData.bag !== 'kilogram' ? (
            <div className={styles.inputGroupFull}>
              <label className={styles.inputLabel}>Item Count</label>
              <input name="count" className={styles.input} type="number" placeholder="Enter Count" value={formData.count} onChange={handleChange} />
              {errors.count && <span className={styles.error}>{errors.count}</span>}
            </div>
          ) : null}

        </div>

        <div className={styles.footerButtons}>
          <button type="button" className={styles.cancel} onClick={onClose}>Cancel</button>
          <button type="button" className={styles.save} onClick={handleSubmit}>Add</button>
        </div>
      </div>
    </div>
  );
};

export default AddItemPopup;



// import React, { useEffect, useRef, useState } from 'react';
// import styles from '../../assets/scss/Invoice/AddItemPopup.module.scss';
// import { useGetItemBagsQuery, useGetItemcatQuery } from '../../slices/admin/admin';
// import { BaseURL } from '../../lib/api';

// const AddItemPopup = ({ onClose, onSave, itemToEdit }) => {
//   const [formData, setFormData] = useState({
//     category: '',
//     description: '',
//     bag: '',
//     quality: '',
//     quantity: '',
//     count: '',
//   });
//   const [imagePreview, setImagePreview] = useState(null);
//   const [imageFile, setImageFile] = useState(null);
//   const fileInputRef = useRef(null);
//   const [errors, setErrors] = useState({});

//   const { data: bagData } = useGetItemBagsQuery();
//   const { data: catData } = useGetItemcatQuery();

//   useEffect(() => {
//     if (itemToEdit) {
//       setFormData({
//         category: itemToEdit.name || '',
//         description: itemToEdit.description || '',
//         bag: itemToEdit.bag || '',
//         quality: itemToEdit.quality || '',
//         quantity: itemToEdit.quantity || '',
//         count: itemToEdit.productCount || '',
//       });

//       // ✅ Fixed image URL handling
//       if (itemToEdit.imagePreview) {
//         setImagePreview(itemToEdit.imagePreview);
//       } else if (itemToEdit.image && typeof itemToEdit.image === 'string') {
//         const fullUrl = itemToEdit.image.startsWith('http')
//           ? itemToEdit.image
//           : `${BaseURL}/${itemToEdit.image}`;
//         setImagePreview(fullUrl);
//       } else {
//         setImagePreview(null);
//       }

//       setImageFile(itemToEdit.image || null);
//     }
//   }, [itemToEdit]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//     setErrors((prev) => ({ ...prev, [name]: '' }));
//   };

//   const validate = () => {
//     const newErrors = {};
//    if (!formData.category) newErrors.category = 'Item Category is required';
//     if (!formData.bag) newErrors.bag = 'Item Scales is required';
//     if (!formData.quality) newErrors.quality = 'Item Quality is required';

//     if (formData.bag === 'kilogram') {
//       if (!formData.quantity) newErrors.quantity = 'Item Quantity is required';
//     } else {
//       if (!formData.count) newErrors.count = 'Item Count is required';
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleImageClick = () => fileInputRef.current.click();

//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setImagePreview(URL.createObjectURL(file));
//       setImageFile(file);
//     }
//   };

//   const handleSubmit = () => {
//     if (validate()) {
//       onSave({
//         name: formData.category,
//         description: formData.description,
//         bag: formData.bag,
//         quality: formData.quality,
//         quantity: formData.bag === 'kilogram' ? Number(formData.quantity) : 0,
//         productCount: formData.bag !== 'kilogram' ? Number(formData.count) : 0,
//         image: imageFile,
//         imagePreview,
//       });
//     }
//   };

//   return (
//     <div className={styles.popupForm}>
//       <div className={styles.header}>
//         <h2 className={styles.tittle}>Add Item</h2>
//         <span className={styles.closeIcons} onClick={onClose}>✕</span>
//       </div>
//       <div className={styles.closeIcon}>
//         <div className={styles.grid}>
//           <div className={styles.uploadBox}>
//             <label className={styles.inputLabel}>Item Image</label>
//             <div className={styles.imageBox}>
//               {imagePreview ? (
//                 <div className={styles.previewWrapper}>
//                   <img src={imagePreview} alt="preview" className={styles.previewImage} />
//                   <button
//                     className={styles.removeBtn}
//                     onClick={() => {
//                       setImagePreview(null);
//                       setImageFile(null);
//                     }}
//                   >
//                     X
//                   </button>
//                 </div>
//               ) : (
//                 <div className={styles.dropArea} onClick={handleImageClick}>
//                   Drag image here<br />or<br /><span>Browse image</span>
//                 </div>
//               )}
//               <input
//                 type="file"
//                 accept="image/*"
//                 ref={fileInputRef}
//                 style={{ display: 'none' }}
//                 onChange={handleImageChange}
//               />
//             </div>
//           </div>

//           <div className={styles.inputGroup}>
//             <label className={styles.inputLabel}>Item Category</label>
//             <select
//               name="category"
//               className={styles.inputs}
//               value={formData.category}
//               onChange={handleChange}
//             >
//               <option value="">Select Item</option>
//               {catData?.getAllItems?.map(item => (
//                 <option key={item._id} value={item.itemCategory}>
//                   {item.itemCategory}
//                 </option>
//               ))}
//             </select>
//             {errors.category && <span className={styles.error}>{errors.category}</span>}
//           </div>

//           <div className={styles.inputGroup}>
//             <label className={styles.inputLabel}>Item Descriptions</label>
//             <input
//               name="description"
//               className={styles.input}
//               type="text"
//               placeholder="Item Descriptions"
//               value={formData.description}
//               onChange={handleChange}
//             />
//           </div>

//           <div className={styles.inputGroup}>
//             <label className={styles.inputLabel}>Item Scales</label>
//             <select
//               name="bag"
//               className={styles.inputs}
//               value={formData.bag}
//               onChange={handleChange}
//             >
//               <option value="">Select Item</option>
//               {bagData?.itemBags?.map(bag => (
//                 <option key={bag._id} value={bag.itemBag}>
//                   {bag.itemBag}
//                 </option>
//               ))}
//             </select>
//             {errors.bag && <span className={styles.error}>{errors.bag}</span>}
//           </div>

//           <div className={styles.inputGroup}>
//             <label className={styles.inputLabel}>Item Quality</label>
//             <select
//               name="quality"
//               className={styles.inputs}
//               value={formData.quality}
//               onChange={handleChange}
//             >
//               <option value="">Select Item</option>
//               <option value="High">High</option>
//               <option value="Medium">Medium</option>
//               <option value="Low">Low</option>
//             </select>
//             {errors.quality && <span className={styles.error}>{errors.quality}</span>}
//           </div>

//           {formData.bag === 'kilogram' ? (
//             <div className={styles.inputGroupFull}>
//               <label className={styles.inputLabel}>Item Quantity (kg)</label>
//               <input
//                 name="quantity"
//                 className={styles.input}
//                 type="number"
//                 placeholder="Enter Quantity"
//                 value={formData.quantity}
//                 onChange={handleChange}
//               />
//               {errors.quantity && <span className={styles.error}>{errors.quantity}</span>}
//             </div>
//           ) : (
//             <div className={styles.inputGroupFull}>
//               <label className={styles.inputLabel}>Item Count</label>
//               <input
//                 name="count"
//                 className={styles.input}
//                 type="number"
//                 placeholder="Enter Count"
//                 value={formData.count}
//                 onChange={handleChange}
//               />
//               {errors.count && <span className={styles.error}>{errors.count}</span>}
//             </div>
//           )}
//         </div>

//         <div className={styles.footerButtons}>
//           <button className={styles.cancel} onClick={onClose}>Cancel</button>
//           <button className={styles.save} onClick={handleSubmit}>Add</button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AddItemPopup;
